
import { Component, Vue, Prop } from "vue-property-decorator";
import HelloWidgetTemplate from "@/components/Widgets/Templates/HelloWidgetTemplate.vue";
import { SMUser } from "@/store";

const ICONS = {
  alert: "alert-circle",
};

@Component({
  components: {
    HelloWidgetTemplate,
  },
})
export default class OnExpertReviewCandidateCosAndSwWidget extends Vue {
  @Prop({ type: String }) readonly jobTitle?: string;
  @Prop({ type: String }) readonly name?: string;
  @Prop({ type: String }) readonly caseType?: string;
  @Prop({ type: String }) readonly listType?: string;

  icons = ICONS;

  get computedProps() {
    const { jobTitle, name, caseType, listType } = this;

    return {
      title: this.$tc(`${caseType}.title`),
      jobTitle,
      name,
      listType,
    };
  }

  getText(target) {
    const { caseType } = this;
    const role = SMUser.user?.role;

    if (!role) return "";

    const path = `${caseType}.${role}.${target}`;

    return this.$t(path) || "";
  }

  get text() {
    return this.getText("text");
  }

  get subtext() {
    return this.getText("subtext");
  }
}
